<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<!-- <script setup>
import { onMounted, ref } from "vue";
import { fetchAuthSession, signOut } from "aws-amplify/auth";

const isAuthenticated = ref(false);

const refreshSession = async () => {
  try {
    const session = await fetchAuthSession({ forceRefresh: true });
    isAuthenticated.value = !!session.tokens?.accessToken;
    console.log("🔄 Session refreshed successfully");
  } catch (error) {
    console.error("⚠️ Session refresh failed, logging out...", error);
    await signOut();
    window.location.href = "/";
  }
};

onMounted(() => {
  refreshSession();
});
</script> -->

<style>
.FontSize8px {
  font-size: 8px !important;
}
.FontSize10px {
  font-size: 10px !important;
}
.FontSize12px {
  font-size: 12px !important;
}
.FontSize14px {
  font-size: 14px !important;
}
.FontSize16px {
  font-size: 16px !important;
}
.FontSize18px {
  font-size: 18px !important;
}
.FontSize20px {
  font-size: 20px !important;
}
.FontSize22px {
  font-size: 22px !important;
}
.FontSize24px {
  font-size: 24px !important;
}
.FontSize25px {
  font-size: 25px !important;
}
.FontSize28px {
  font-size: 28px !important;
}
.FontSize30px {
  font-size: 30px !important;
}
.FontSize35px {
  font-size: 35px !important;
}
.FontSize40px {
  font-size: 40px !important;
}
.TableClassStyle th {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: rgb(137, 132, 132) !important;
  text-transform: uppercase !important;
}
.v-messages {
  text-align: left !important;
}

.TableClassStyle td {
  font-size: 12px !important;
  font-weight: 500 !important;
  letter-spacing: 0.007142 !important;
  color: #0f0f0fdd !important;
  font-family: "roboto", sans-serif !important;
}
.CursorVariant {
  cursor: pointer !important;
}
.FontFamilyVariant1 {
  font-family: Goudy Old Style !important;
  font-weight: 600;
  font-size: 20px !important;
}
.FontFamilyVariant2 {
  font-family: "Roboto", sans-serif !important;
  font-weight: 600;
  font-size: 36px !important;
}
.FontFamilyVariant3 {
  font-family: "Roboto", sans-serif !important;
  font-weight: 700;
  font-size: 18px !important;
}
.AddFieldForm {
  font-size: 14px !important;
  color: #0505057f !important;
  font-weight: 500 !important;
  letter-spacing: 0.55px !important;
}
.MaxFieldwidth {
  max-width: 300px !important;
}
.Cursormove {
  cursor: move !important;
}
.HoverBtn {
  background: #f03f44 !important;
  color: white !important;
  border-radius: 7px !important;
}
.HoverBtn:hover {
  background: black !important;
}
.btnRadius {
  border-radius: 20px !important;
}
.ToolbarRadius {
  border-radius: 25px !important;
}
.custom-chip {
  max-width: 100px; /* Adjust as needed */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.truncate-text {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ListClassStyle li {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.009375em;
  line-height: 1.5;
  text-transform: none;
}
.FullWidthField {
  min-width: 73vw !important;
  max-width: 73vw !important;
}
.TableBorderRadius {
  border-radius: 15px !important;
  overflow-y: hidden !important;
}
.no-drop {
  pointer-events: none;
}
.no-drop v-btn,
.no-drop v-icon {
  pointer-events: auto;
}
.Tabbtn {
  border-radius: 10px !important;
}
.SelectStyle {
  max-width: 100px !important;
}
.v-tab {
  border-radius: 20px !important;
}
.v-data-table__wrapper {
  overflow-y: hidden !important;
}
.roundedBorderRadius {
  border-radius: 25px !important;
}
</style>
